import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ReactTable from '../ReactTable';
import { logsApplicationTableColumns } from "../../helpers/tabs_helper";
import { format } from "date-fns";

const ApplicationsEventsTable = ({
  data,
  isLoading,
  onSortChange,
  disableSortBy = false,
  onRowClick
}) => {
  const statusColor = (statusCode) => {
    if (statusCode >= 100 && statusCode <= 299) {
      return 'good';
    }
    if (statusCode >= 300 && statusCode <= 399) {
      return 'warning';
    }
    return 'critical';
  };

  // const appStatus = (status, responseCode) => {
  //   switch (status) {
  //     case true:
  //       return (
  //         <span className={`result-status ${responseCode ? statusColor(responseCode) : 'result-success'}`}>
  //           Reachable{responseCode ? `, ${responseCode}` : ''}
  //         </span>
  //       );
  //     default:
  //       return (
  //         <span className={`result-status ${responseCode ? statusColor(responseCode) : 'result-danger'}`}>
  //           Not Reachable{responseCode ? `, ${responseCode}` : ''}
  //         </span>
  //       );
  //   }
  // };

  const transformUrl = (url) => {
    const hasProtocol = /^http[s]?:\/\//.test(url);
    const modifiedUrl = hasProtocol ? url : `http://${url}`;
    return modifiedUrl;
  };

  const columns = [
      {
        Header: logsApplicationTableColumns.APPLICATION.header,
        accessor: logsApplicationTableColumns.APPLICATION.accessor,
        Cell: ({row: {original}}) => {
          return <a href={transformUrl(original?.appUrl)} target="_blank" rel="noreferrer">{original?.appName}</a>;
        }
      },
      {
        Header: logsApplicationTableColumns.STATUS.header,
        accessor: logsApplicationTableColumns.STATUS.accessor,
        Cell: ({row: {original}}) => {
          return (
            <span className={`application-status-text ${original?.httpResponseCode ? statusColor(original.httpResponseCode) : ''}`}>
              {original?.reachable ? 'Reachable' : 'Not Reachable'}
            </span>
          );
        },
      },
      {
        Header: logsApplicationTableColumns.START_TIME.header,
        accessor: logsApplicationTableColumns.START_TIME.accessor,
        Cell: ({row: {original}}) => {
          const startTimeAccessor = logsApplicationTableColumns.START_TIME.accessor;
          if (!original[startTimeAccessor]) {
            return 'N/A';
          }
          const date = new Date(original[startTimeAccessor]);
          return format(date, 'MMM dd, yyyy HH:mm:ss');
        },
      },
      {
        Header: logsApplicationTableColumns.END_TIME.header,
        accessor: logsApplicationTableColumns.END_TIME.accessor,
        Cell: ({row: {original}}) => {
          const endTimeAccessor = logsApplicationTableColumns.END_TIME.accessor;
          if (!original[endTimeAccessor]) {
            return 'N/A';
          }
          const date = new Date(original[endTimeAccessor]);
          return format(date, 'MMM dd, yyyy HH:mm:ss');
        },
      },
      {
        Header: logsApplicationTableColumns.DURATION.header,
        accessor: logsApplicationTableColumns.DURATION.accessor,
        Cell: ({row: {original}}) => {
          if (original?.issueStart && original?.issueEnd) {
            const start = new Date(original.issueStart);
            const end = new Date(original.issueEnd);
            const duration = Math.abs(end - start);
            const seconds = Math.floor(duration / 1000);
            const minutes = Math.floor(duration / 60000); // Convert to minutes

            return minutes > 0 ? `${minutes} min` : `${seconds} sec`;
          }
          return 'N/A';
        },
      },
    ];

  const onSort = useCallback(({sortBy}) => {
    if (onSortChange) {
      if (sortBy.length > 0) {
        const [{id, desc}] = sortBy;
        onSortChange(`${[id]} ${desc ? 'desc' : 'asc'}`);
      } else {
        onSortChange();
      }
    }
  }, []);

  return (
    <ReactTable
      className="applications-table"
      columns={columns}
      data={data}
      onSortChange={onSort}
      loading={isLoading}
      manualSortBy
      disableMultiSort
      disableSortBy={disableSortBy}
      onRowClick={onRowClick}
    />

  );
};

ApplicationsEventsTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any),
  onSortChange: PropTypes.func,
  isLoading: PropTypes.bool,
};

const mapStateToProps = (state) => {
  const { error, loading } = state.Applications;
  return { error, loading };
};

export default withRouter(connect(mapStateToProps, {})(ApplicationsEventsTable));
